module.exports = __webpack_public_path__ + "img/10_99.7c6e7f4d.png";